export default "__VITE_ASSET__DWNrcOXT__"